export default __webpack_public_path__ + "static/media/pic1.18b53e95.jpg";